import { create } from 'zustand'
import type { User, Room, ChatMessage, AgentEvent, Idea, UserPresence } from '../types'

interface AppState {
  currentRoom: Room | null
  user: User | null
  usersOnline: UserPresence[]
  ideas: Idea[]
  chatMessages: ChatMessage[]
  agentEvents: AgentEvent[]
  activeTool: 'select' | 'pen' | 'idea' | 'agent' | 'hand'
  darkMode: boolean
  // actions
  setRoom: (room: Room | null) => void
  setUser: (user: User | null) => void
  setUsersOnline: (users: UserPresence[]) => void
  addChatMessage: (msg: ChatMessage) => void
  addIdea: (idea: Idea) => void
  addAgentEvent: (event: AgentEvent) => void
  setActiveTool: (tool: AppState['activeTool']) => void
  toggleDarkMode: () => void
}

export const useAppStore = create<AppState>((set) => ({
  currentRoom: null,
  user: null,
  usersOnline: [],
  ideas: [],
  chatMessages: [],
  agentEvents: [],
  activeTool: 'select',
  darkMode: false,

  setRoom: (room) => set({ currentRoom: room }),
  setUser: (user) => set({ user }),
  setUsersOnline: (users) => set({ usersOnline: users }),
  addChatMessage: (msg) => set((state) => ({ chatMessages: [...state.chatMessages, msg] })),
  addIdea: (idea) => set((state) => ({ ideas: [...state.ideas, idea] })),
  addAgentEvent: (event) => set((state) => ({ agentEvents: [...state.agentEvents, event] })),
  setActiveTool: (tool) => set({ activeTool: tool }),
  toggleDarkMode: () => set((state) => {
    const next = !state.darkMode
    document.documentElement.classList.toggle('dark', next)
    localStorage.setItem('darkMode', String(next))
    return { darkMode: next }
  }),
}))
